<template>
  <div class="resource-wap">
    <a-modal class="resource-modal" :visible="isShowResource" v-bind="$attrs" v-on="$listeners" :closable="true"
      :maskClosable="true" @cancel="handleCancel" :dialogStyle="dialogStyle" :footer="null">
      <div class="res-info">
        <div class="res-head">
          <div class="res-tit">资料</div>
          <!-- <div class="resource-delete" @click="isShowResource = false"><img :src="closeImg" alt="" /></div> -->
        </div>
        <div class="resource" v-if="resourceList && resourceList.length > 0">
          <div v-for="(item, index) of resourceList" class="resource-item" :key="index" @click="goToRes(item)">
            <div class="flex" style="width: 80%">
              <div v-if="item.resType === 'exam'"><img class="resource-icon" src="../img/homework.png" /></div>
              <div v-if="item.resType === 'attach'"><img class="resource-icon" src="../img/doc-icon.png" /></div>
              <div v-if="item.resType === 'doc'"><img class="resource-icon" src="../img/ppt-icon.png" /></div>
              <div class="res-wap">
                <div class="class-title">{{ item.title }}</div>
                <div class="res-time">
                  <span v-if="item.createTime">{{ item.createTime | moment('YYYY-MM-DD') }}</span>
                </div>
              </div>
            </div>
            <div class="res-btn">
              <span v-if="item.resType === 'attach'">下载</span>
              <span v-if="item.resType === 'exam'">做题</span>
              <span v-if="item.resType === 'doc'">下载</span>
            </div>
          </div>
        </div>
        <div class="space-info resource" v-else>
          <img class="blank-bg" src="../img/blank-bg.png" />
          <div>暂无资料～</div>
        </div>
      </div>
    </a-modal>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { transformUrl } from '@/utils/util'
import closeImg from '@/assets/icons/close.png'
import Vue from 'vue'
export default {
  data() {
    return {
      itemUrls: [],
      scheduleList: [],
      isShowResource: false,
      studentData: {},
      resourceList: [],
      closeImg,
      dialogStyle: {
        right: 0,
        position: 'fixed',
        top: '80px',
        height: '60%',
      },
    }
  },
  props: {},
  created() {
    this.getSchudelId()
    this.initData()
  },
  computed: {
    ...mapState('course', ['scheduleId', 'planclassesId', 'classesId']),
    otherSchedules() {
      return this.scheduleList.filter((el) => el.id !== this.scheduleId)
    },
    currentSchueules() {
      const filter = this.scheduleList.filter((el) => el.id === this.scheduleId)
      return filter.length > 0 ? filter[0] : null
    },
  },
  methods: {
    initData() {
      if (this.$route.query) {
        this.studentData = this.$route.query
      }
    },
    async show(item) {
      this.isShowResource = true
      document.querySelector('body').setAttribute('style', 'width: calc(100% - 17px)')
      this.resourceList = await this.$http.get('/b/classes/web/stu/schedule/resource/v2/' + item.scheduleId)
    },
    // 资源列表点击事件
    async goToRes(res, thisPage) {
      console.log('activityInfo', this.activityInfo)
      const restype = res.resType
      switch (restype) {
        case 'doc':
          this.loadHandout(res)
          break
        case 'exam':
          if (thisPage) {
            // let Url =
            //   'exam/l/' + res.id + '/' + this.classesId + '/' + this.planclassesId + '/1'
            // this.examUrl = this.sanitizer.bypassSecurityTrustResourceUrl(Url);
            await this.$http.get(
              `/b/classes/web/stu/schedule/resource/resource/exam/${this.studentData.planclassesId}/${this.studentData.classesId}/${this.studentData.scheduleId}/${res.id}`
            )
          } else {
            this.goToHomeWork(res)
            // window.open('https://lss.51lss.com/exam/e/' + res.id + '/' + this.studentData.classesId + '/' + this.studentData.planclassesId)
          }
          break
        case 'topic':
          // this.clickTopic(res, thisPage);
          break
        case 'video':
          // this.loadVideo(res);
          break
        case 'sand':
          // window.open(res.url);
          break
        case 'attach':
          const item = await this.$http.get(
            `/b/classes/web/stu/schedule/resource/${this.studentData.scheduleId}/${res.id}`
          )
          const url = transformUrl(item.urls[0])
          console.log('item', item, res)
          this.download(item.urls[0], res.title)
          // window.open(url)
          break
        case 'web':
          // window.open(res.urlForWeb);
          break
        case 'audio':
        case 'ebook':
        case 'interview':
          this.reminder()
          break

        default:
      }
    },
    // 解析ppt
    async loadHandout(doc) {
      console.log('doc', doc)
      this.download(doc.url, doc.title)
      // window.open(doc.url)
      // const res = await this.$http.get(`/b/classes/web/stu/schedule/resource/${this.studentData.scheduleId}/${doc.id}`)
      // if (this.activityInfo.scene === 'ppt') {
      //   const url = transformUrl(res.urls[0])
      //   window.open(url)
      // } else {
      //   this.$emit('analysisPPt', res.urls)
      // }
    },
    getResorce() {
      this.$emit('getResorce')
    },
    callback() {
      console.log('callback')
    },
    async getSchudelId() {
      const params = {
        classesId: this.classesId,
      }
      this.scheduleList = await this.$http.get('/b/classes/web/stu/schedule/listByClassesId', {
        params,
      })
    },
    goToOtherSchedule(item) {
      this.$router.push({
        name: 'watchV2Index',
        query: { scheduleId: item.id, planclassesId: this.planclassesId, classesId: this.classesId },
      })
    },
    handleCancel() {
      this.isShowResource = false
    },
    goToHomeWork(item) {
      // this.$router.push({
      //   name: 'homeWork',
      //   params: {
      //     classesId: item.classesId || this.studentData.classesId,
      //     planclassesId: item.planclassesId || this.studentData.planclassesId,
      //     scheduleId: item.scheduleId || this.studentData.scheduleId,
      //     done: item.done,
      //     examId: item.id,
      //     examName: item.name,
      //     // id: '81e2706b39e57a8c88784e2914651a43', // 试卷id
      //     knowId: item.knowId,
      //     seq: null,
      //   },
      // })
      const routeInfo = this.$router.resolve({
        name: 'homeWork',
        query: {
          classesId: item.classesId || this.studentData.classesId,
          planclassesId: item.planclassesId || this.studentData.planclassesId,
          scheduleId: item.scheduleId || this.studentData.scheduleId,
          done: item.done,
          examId: item.examId,
          examName: item.title,
          id: item.scheduleExamId,
          knowId: item.knowId,
          ocode: Vue.ls.get('code'),
          seq: null,
        },
      })
      window.open(routeInfo.href, '_blank')
    },
    download(downloadUrl, downloadFileName) {
      var suffix = downloadUrl.substr(downloadUrl.lastIndexOf('.'))
      this.getBlob(downloadUrl).then(blob => {
        this.saveAs(blob, downloadFileName + suffix)
      })
    },
    getBlob(url) {
      return new Promise(resolve => {
        const xhr = new XMLHttpRequest()
        xhr.open('GET', url, true)
        xhr.responseType = 'blob'
        xhr.onload = () => {
          if (xhr.status === 200) {
            resolve(xhr.response)
          }
        }
        xhr.send()
      })
    },
    saveAs(blob, filename) {
      var link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = filename
      link.click()
    },
  },
  components: {},
}
</script>
<style scoped lang="less">
/deep/ .ant-modal-content {
  border-radius: 0;
  height: 100%;
}

/deep/.ant-modal-body {
  padding: 0;
}

.resource {
  overflow: auto;
  // position: absolute;
  // top: 45px;
  // bottom: 0;
  // left: 0;
  // right: 0;
  font-size: 16px;
  // height: 652px;
  height: calc(100vh - 50px);

  .class-title {
    color: #303133;
    line-height: 20px;
    font-size: 14px;
    font-weight: bold;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
  }

  .res-time {
    line-height: 18px;
    font-size: 12px;
    color: #84878d;
  }

  .resource-item {
    background-color: #fff;
    padding: 10px;
    border-radius: 10px;
    margin: 10px;
    align-items: center;
    display: flex;
    justify-content: space-between;
    transition: all .2s;

    // box-shadow: 0px 0px 10px 0px rgba(190,190,190,0.5);
    // margin: 6%;
    &:hover {
      cursor: pointer;
      box-shadow: 0px 2px 16px 0px rgba(0, 0, 0, 0.07);
    }
  }

  .res-wap {
    padding: 5px 0;
    width: 70%;
  }
}

.text-gray {
  color: #999999;
  font-size: 14px;
}

.text-blue {
  color: #259dd3;
}

/deep/ .ant-tabs-bar {
  border: none;
}

/deep/ .ant-tabs-nav {
  width: 100%;
  color: #666666;
  font-size: 16px;

  div {
    display: flex;
    justify-content: space-around;
  }

  .ant-tabs-tab-active {
    border-bottom: 3px #1890ff solid;
    color: #fff;
  }

  .ant-tabs-tab {
    margin: 0;
    padding-left: 30px;
    padding-right: 30px;
    font-size: 18px;
  }

  .ant-tabs-ink-bar {
    display: none !important;
  }
}

.icon {
  height: 18px;
  width: 18px;
  margin-left: 8px;
}

.course-panel {
  padding: 0 20px;
  color: #999999;
  overflow: auto;
  position: absolute;
  top: 45px;
  bottom: 0;
  left: 0;
  right: 0;

  .title {
    color: #fff;
    font-size: 16px;
    margin-bottom: 14px;
  }

  .panel-item {
    .text {
      margin-left: 12px;
    }
  }

  .item {
    cursor: pointer;
    color: #999999;

    &:first-child {
      margin-top: 0;
    }

    &.select {
      color: #259dd3;
    }
  }
}

.text-white {
  color: #ffffff;
}

.margin-left-sm {
  margin-left: 10px;
}

.flex {
  display: flex;
}

.align-center {
  align-items: center;
}

.hide-icon {
  visibility: hidden;
}

.text-right {
  text-align: right;
}

.relative {
  position: relative;
}

.res-info {
  // position: fixed;
  // background-color: #fff;
  // right: 0px;
  // top: 120px;
  // width: 452px;
  // z-index: 9999;
  // height: calc(100% - 20px);
}

.res-head {
  height: 50px;
  line-height: 40px;
  display: flex;
  justify-content: space-between;
  padding: 0 20px;
}

.resource-delete {
  font-size: 18px;
  color: #fff;
  cursor: pointer;
  position: absolute;
  right: 15px;
}

.resource-image {
  position: absolute;
  top: 45%;
  right: 10px;
  width: 50px;
  height: 53px;
}

.resource-icon {
  width: 42px;
  height: 42px;
  margin-top: 3px;
  margin-right: 5px;
}

.res-btn {
  width: 60px;
  height: 32px;
  line-height: 32px;
  border: 1px solid #4b7dfd;
  text-align: center;
  color: #fff;
  background: #4b7dfd;
  border-radius: 4px;
  font-size: 12px;
  margin-right: 10px;
}

.res-info.ppt-top {
  top: 42%;
  height: calc(100% - 30%);
}

.res-info.active-top {
  top: 60px;
  height: calc(100% - 60px);
}

.resource-delete img {
  width: 15px;
  height: 15px;
}

.res-tit {
  font-size: 16px;
  font-weight: 500;
  color: #303133;
  line-height: 22px;
  text-align: center;
  margin: auto;
}

.space-info {
  display: flex;
  justify-content: center;
  align-content: center;
  flex-direction: column;
  text-align: center;
  padding-bottom: 60px;
}

.blank-bg {
  width: 150px;
  height: 150px;
  margin: 0 auto 20px auto;
}
</style>
<style>
.resource-modal .ant-modal-mask {
  z-index: 10;
}

.resource-modal .ant-modal-wrap {
  z-index: 10;
}

.resource-modal .ant-modal {
  top: 0 !important;
  height: 100vh !important;
  border-radius: 0 !important;
  padding-bottom: 0 !important;
  margin-top: 0 !important;
}
</style>
